import request from 'app/api/request';
import ServerErrorHandler from 'app/ErrorHandler';
import { useQuery, UseQueryResult } from 'react-query';
import { TagAnalysisResponse, UUID } from './types';

export const tagAnalysisQueryKeys = {
  analysis: 'TAG_ANALYSIS',
} as const;

export function useTagAnalysis(documentSuperId?: number, tagId?: UUID | null): UseQueryResult<TagAnalysisResponse | null> {
  return useQuery(
    [tagAnalysisQueryKeys.analysis, documentSuperId, tagId],
    async () => {
      if (!tagId) return null;
      const res = await request.get(`/gaby/tags/${tagId}/analysis`).catch((err: { status: number }) => {
        if (err.status === 404) return null;
        throw err;
      });
      return (res?.data as TagAnalysisResponse) || null;
    },
    {
      enabled: !!documentSuperId && !!tagId,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      onError: ServerErrorHandler,
    }
  );
}
